import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nzortaxon-name-list',
  templateUrl: './nzortaxon-name-list.component.html',
})
export class NZORTaxonNameListComponent implements OnInit {
  @Input()
  nzorName;

  constructor() {}

  ngOnInit() {}

  namesInReverse(): any[] {
    const reversed = this.nzorName.classificationNames.toReversed();

    if (reversed.at(-1).fullName === "ROOT") {
      reversed.pop();
    }

    return reversed;
  }
}
